import {
  OperationType,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';

export const getMutatedWhereClauseWithL1Values = (
  whereClause: WhereClause,
  l1IDs?: string[],
): WhereClause => {
  if (
    l1IDs &&
    whereClause?.filter?.entityFilter &&
    !whereClause.filter.entityFilter.l1IDs
  ) {
    return {
      ...whereClause,
      filter: {
        type: whereClause.filter.type,
        entityFilter: {
          ...whereClause.filter.entityFilter,
          l1IDs,
        },
      },
    };
  }

  if (whereClause.op) {
    const l1IDsInParam =
      !l1IDs && whereClause?.op.type === OperationType.AND
        ? whereClause.op.params.find(
            (param) => !!param?.filter?.l1Filter?.l1IDs.length,
          )?.filter?.l1Filter?.l1IDs
        : l1IDs;

    return {
      ...whereClause,
      op: {
        ...whereClause.op,
        params: whereClause.op.params.map((param) =>
          getMutatedWhereClauseWithL1Values(param, l1IDsInParam),
        ),
      },
    };
  }

  return whereClause;
};
